import React, { useRef, useEffect } from 'react';
import store from './store';
import { observer } from 'mobx-react-lite';
import { Dialog, message } from '@tencent/spaui';
import { ListView } from '@tencent/ptp-fe-common';
import getTableConfig from './config/getTableConfig';
import { post } from 'store/request';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { getCsIndustryTree } from 'store/manager';
import dialog from 'utils/dialog';

const options = ({ payloads, customFunctions }) => {
  const { id, csIndustryTree, item } = payloads;
  const { viewAgencyDetail, toggleEnterStatue, toggleHitStatus } = customFunctions;
  return {
    fetchConfig: {
      action: () => {
        return post(`/demand/tender_agency_list/${id}`, {}, 'v2');
      },
      $onRequest(params) {
        return {
          ...params,
          // propsData: listData,
        };
      },
      $onResponse(list) {
        if (!list || list.length === 0) {
          return {
            list: [],
            page_info: {
              total_number: 0,
            },
          };
        }
        return {
          list,
          page_info: {
            // total_number: conf.totalCount,
            total_number: 0,
          },
        };
      },
    },
    tableConfig: getTableConfig({
      viewAgencyDetail,
      toggleEnterStatue,
      toggleHitStatus,
      csIndustryTree,
      item,
    }),
  };
};

const App = () => {
  const listRef = useRef(null);
  const { show, id, item } = store;
  const handleClose = () => {
    store.closeAgencyDialog();
  };

  const {
    manager: { csIndustryTree },
  } = useTypedSelector((state) => state);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getCsIndustryTree());
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  const viewAgencyDetail = (item) => {
    return post(
      '/demand/get_material_user/',
      {
        agency_id: item.agency_id,
        demand_id: id,
      },
      'v2'
    ).then((res) => {
      if (!res || res.length === 0) {
        message.warn('暂无补充资料');
        return;
      }
      dialog.alert(
        <div>
          {res.map((item, index) => (
            <div key={index}>
              <a href={item.path} target="_blank" rel="noreferrer">
                {item.name}
              </a>
            </div>
          ))}
        </div>,
        {
          title: '补充资料',
        }
      );
    });
    // const list = [111, 222, 333];
    // dialog.alert(
    //   <div>
    //     {list.map((item, index) => (
    //       <div key={index}>
    //         <a href={item} target="_blank" rel="noreferrer">
    //           {item}
    //         </a>
    //       </div>
    //     ))}
    //   </div>,
    //   {
    //     title: '补充资料',
    //   }
    // );
  };

  const reloadData = () => {
    listRef.current?.loadList();
  };

  const toggleEnterStatue = (item, bool) => {
    console.log('切换竞选状态', item, bool);
    // if (item.)
    // 选中服务商竞标-用户视角
    if (bool) {
      post(
        '/demand/success_choose_tender/',
        {
          demand_id: id,
          agency_id: item.agency_id,
        },
        'v2'
      ).then(() => {
        reloadData();
        message.success('操作成功');
      });
    }

    // 取消服务商竞标-用户视角
    if (!bool) {
      post(
        '/demand/fail_choose_tender/',
        {
          demand_id: id,
          agency_id: item.agency_id,
        },
        'v2'
      ).then(() => {
        reloadData();
        message.success('操作成功');
      });
    }
  };

  const toggleHitStatus = (item, bool) => {
    console.log('切换中标状态', item, bool);
    // 确认中标
    if (bool) {
      post(
        '/demand/confirm_tender/',
        {
          demand_id: id,
          agency_id: item.agency_id,
        },
        'v2'
      ).then(() => {
        reloadData();
        message.success('操作成功');
      });
    }

    // 取消中标
    if (!bool) {
      post(
        '/demand/cancel_tender_user/',
        {
          demand_id: id,
          agency_id: item.agency_id,
        },
        'v2'
      ).then(() => {
        reloadData();
        message.success('操作成功');
      });
    }
  };

  return (
    <Dialog
      position="right"
      animation
      animationName="smoothIn"
      className="with-full-height"
      show={show}
      onClose={handleClose}
      onSubmit={handleClose}
      onCancel={handleClose}
      title={'参与服务商列表'}
      hideFooter
      footerStyle={{
        textAlign: 'center',
      }}
    >
      <ListView
        ref={listRef}
        className="crm-table-list enter-agency-list"
        options={options}
        payloads={{
          id,
          csIndustryTree,
          item,
        }}
        customFunctions={{
          viewAgencyDetail,
          toggleEnterStatue,
          toggleHitStatus,
        }}
      />
    </Dialog>
  );
};

export default observer(App);
